import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appendToAssistantDetail } from '../../store/app/assistantSlice';

function SummaryComponent() {
  const dispatch = useDispatch();
  const assistantDetails = useSelector((state) => state.assistants.activeDetail.details);
  const initialContent =
    assistantDetails?.analysisPlan?.summaryPlan?.messages?.[0]?.content || '';
  const [prompt, setPrompt] = useState(initialContent);

  useEffect(() => {
    if (prompt === undefined || prompt === null) return;

    const existingPlans = assistantDetails?.analysisPlan || {};

    const updatedAnalysisPlan = {
      ...existingPlans,
      summaryPlan: {
        messages: [
          {
            role: 'system',
            content: prompt,
          },
        ],
      },
    };

    dispatch(appendToAssistantDetail({ analysisPlan: updatedAnalysisPlan }));
  }, [prompt, dispatch, assistantDetails?.analysisPlan]);

  return (
    <div className="card">
      <div
        style={{
          borderTopRightRadius: '8px',
          borderTopLeftRadius: '8px',
          backgroundColor: '#f1f3f5',
          padding: '10px 20px',
        }}
      >
        <div>Summary</div>
        <div className="text-xs mb-10">
          This is the prompt that's used to summarize the call. The output is stored in <code>call.analysis.summary</code>.
        </div>
      </div>

      <div style={{ padding: '10px 20px' }}>
        <div>Prompt</div>
        <div className="text-xs mb-10">
          This is the prompt that's used to generate the summary of the call.
        </div>
        <textarea
          style={{ height: '300px' }}
          placeholder={prompt === "" ? "You are an expert note-taker. You will be given a transcript of a call. Summarize the call in 2-3 sentences, if applicable." : prompt}
          id="agent-prompt"
          className="agent-form-textarea agent-form-textarea::placeholder"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>
    </div>
  );
}

export default SummaryComponent;
